// extracted by mini-css-extract-plugin
module.exports = {"selectAskPerson":"selectAskPerson__9oot3","input":"input__5P5Jo","button":"button__xu1u6"};